import {
  EffectAxis,
  MouseEffectConfig,
  MouseEffectParams,
  SchemaGroup,
  UnitLengthPercentage,
} from '../../types';
import {
  transitionDuration,
  mouseEasing,
  mouseDistance as distance,
  inverted,
  angle,
  axis,
} from '../baseParams';

export interface SkewMouse extends MouseEffectParams {
  distance: UnitLengthPercentage;
  angle: number;
  axis: EffectAxis;
}

const name = 'SkewMouse';
const groups: SchemaGroup[] = ['mouse', 'animation'];

export const config: MouseEffectConfig<SkewMouse> = {
  name,
  groups,
  schema: {
    transitionDuration: { ...transitionDuration, step: 10, default: 250 },
    inverted: { ...inverted, default: true },
    transitionEasing: { ...mouseEasing },
    distance: { ...distance, min: 5, default: { value: 80, type: 'px' } },
    angle: { ...angle, min: 5, max: 50, default: 25 },
    axis: { ...axis },
  },
} as const;

export const responsiveConfig: MouseEffectConfig<SkewMouse> = {
  name,
  groups,
  schema: {
    transitionDuration: { ...transitionDuration, step: 10, default: 250 },
    inverted: { ...inverted, default: true },
    transitionEasing: { ...mouseEasing },
    distance: { ...distance, min: 5, default: { value: 80, type: 'px' } },
    angle: { ...angle, min: 5, max: 50, default: 25 },
    axis: { ...axis },
  },
} as const;
